<script lang="ts">
import SectionRib from '@/generated/sections/SectionRib.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionRib
})

</script>
